import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import { func, object } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';
import { useGetEffectiveAiConfigQuery } from 'store/app/entities/AiConfigSlice';

const DEFAULT_KEY = '';

const resolveSelectedKey = (model, catalog, defaultKey) => {
  if (model?.modelKey && catalog[model.modelKey]) return model.modelKey;
  if (model?.id) {
    const match = Object.entries(catalog).find(([, entry]) => entry.modelId === model.id);
    if (match) return match[0];
  }
  return defaultKey || DEFAULT_KEY;
};

const AgentModelCard = ({ draft, onPatch }) => {
  const { data, isLoading } = useGetEffectiveAiConfigQuery();
  const catalog = useMemo(() => data?.effective?.models || {}, [data?.effective?.models]);
  const defaultKey = data?.effective?.defaults?.defaultModelKey || 'haiku';
  const modelKeys = useMemo(() => Object.keys(catalog), [catalog]);

  const selectedKey = resolveSelectedKey(draft.model, catalog, defaultKey);

  const handleChange = key => {
    if (!key || key === DEFAULT_KEY) {
      onPatch('model', {});
      return;
    }
    const entry = catalog[key];
    if (!entry) return;
    onPatch('model', {
      modelKey: key,
      provider: entry.provider,
      id: entry.modelId,
      temperature: draft.model?.temperature,
      maxTokensPerTurn: draft.model?.maxTokensPerTurn,
    });
  };

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          mb: 2,
        }}
      >
        {I18n.t('AgenticChatFlow.ModelTitle')}
      </Typography>
      <FormControl fullWidth size="small" disabled={isLoading}>
        <InputLabel>{I18n.t('AgenticChatFlow.ModelLabel')}</InputLabel>
        <Select
          label={I18n.t('AgenticChatFlow.ModelLabel')}
          value={selectedKey || defaultKey}
          onChange={e => handleChange(e.target.value)}
        >
          <MenuItem value={defaultKey}>
            {I18n.t('AgenticChatFlow.ModelPlatformDefault', {
              name: catalog[defaultKey]?.label || defaultKey,
            })}
          </MenuItem>
          {modelKeys
            .filter(key => key !== defaultKey)
            .map(key => (
              <MenuItem key={key} value={key}>
                {catalog[key]?.label || key}
                {catalog[key]?.provider ? ` (${catalog[key].provider})` : ''}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          mt: 1,
          display: 'block',
        }}
      >
        {I18n.t('AgenticChatFlow.ModelHint')}
      </Typography>
    </Box>
  );
};

AgentModelCard.propTypes = {
  draft: object.isRequired,
  onPatch: func.isRequired,
};

export default AgentModelCard;
